import { APIScope, InheritanceStatus, MatrixQuestInterface, QuestType } from "@swivl-mono/types";
import { useEffect } from "react";
import { useMatch } from "react-router-dom";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";
import { useSwivlNavigate } from "../../Models/NavBar/useSwivlNavigate";
import { QuestsModel } from "../../Models/Quests/Quests.Model";
import MatrixView from "./MatrixView/MatrixView";
import { EditorCanvas } from "./Quest/Canvas/EditorCanvas";

export default function EditorWrapper() {
  //
  const { quests, workflows } = QuestsModel.useState((s) => s);
  // const { bot }            = BotModel.useState((s)=> s)
  // const { user }          = UserModel.useState((s)=> s)

  const navigate = useSwivlNavigate();

  const canEditWorkflows = useHasPermission(APIScope.WORKFLOWS_EDIT);

  const match = useMatch("/quest/:slug");

  useEffect(() => {
    if (match && match.params && match.params.slug) {
      QuestsModel.loadQuestsList(false).then(() => {
        if (match && match.params && match.params.slug) {
          QuestsModel.loadQuest(match.params.slug, true);
        }
      });
    }
  }, [match]);

  // const quest = QuestsModel.useQuest(match.params.id)

  if (!quests) {
    return <PageLoadingView navBarTitle=" " pageTitle=" " />;
  }
  const quest = match && quests ? quests[match.params.slug!] : undefined;

  if (match && quests && !quest) return <div>Quest not found</div>;
  if (quest && !quest.data) {
    return <PageLoadingView navBarTitle=" " pageTitle=" " />;
  }

  const canEdit = quest?.inheritance !== InheritanceStatus.IS_PARENT && canEditWorkflows;

  if (quest?.type === QuestType.MATRIX) {
    return <MatrixView matrix={quest as MatrixQuestInterface} workflows={workflows} canEdit={canEdit} />;
  }

  return <EditorCanvas key={quest!.slug} navigate={navigate} quest={quest!} canEdit={canEdit} />;
}
